<template>
  <div class="container">
    <div class="wrap"><p>© Copyright by IK.</p></div>
  </div>
</template>

<script>
export default { name: "FooterComponent" };
</script>

<style lang="scss" scoped>
.container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .wrap {
    background-image: linear-gradient(
      to bottom,
      #fff 50%,
      #2f9e44 50%,
      #2f9e44 85%,
      #fff 85%
    );
    text-align: center;
    padding: 1rem;

    p {
      padding: 0 5rem;
      font-size: 1.5rem;
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }
  }
}
</style>
